module.exports = __webpack_public_path__ + "media/stylesheets/images/main/myclass_sample1-a760e05ea873ca4abebe209fdeab6a3c.png";